<template>
  <div class="createOrEditRoot">
    <div class="resourceFormPage divContainer collectionModule">
      <div v-if="loading" v-loading="loading" class="fullContainer" />
      <div v-else class="resourceFormPage__layout">
        <el-form
          label-position="top"
          size="small"
          class="resourceFormPage__form"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
        >
          <div class="resourceFormPage__headerDock">
            <header class="resourceFormPage__actionBar">
              <div class="resourceFormPage__lead">
                <h1 class="resourceFormPage__pageTitle">
                  {{ isCreate ? '创建分类' : '编辑分类' }}
                </h1>
                <span v-if="!isCreate && typeDisplayLabel" class="resourceFormPage__typeReadonly">
                  {{ typeDisplayLabel }}
                </span>
              </div>
              <div class="resourceFormPage__actions">
                <button
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--ghost"
                  @click="goBack"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--primary"
                  @click="submitForm"
                >
                  保存
                </button>
              </div>
            </header>
          </div>

          <main ref="formMain" class="resourceFormPage__main main">
            <classify-form-shell
              :rule-form="ruleForm"
              :is-create="isCreate"
              :type-options="typeOptions"
              :data-options="dataOptions"
              :upload-loading="uploadLoading"
              :show-type-field="isCreate"
              @cover-upload="customRequest"
              @cover-cleared="onCoverCleared"
            />
          </main>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadFile, getClassifyResourceType } from '../../../api/comment'
import {
  getCategoryById,
  editCategory,
  createCategory,
  getAllDataList,
} from '../../../api/classifyManage'
import ClassifyFormShell from './ClassifyFormShell.vue'

export default {
  name: 'ClassifyCreateOrEdit',
  components: {
    ClassifyFormShell,
  },
  data() {
    return {
      ruleForm: {
        name: '',
        type: '',
        title: '',
        key: '',
        country: {
          isExclude: true,
          countries: [],
        },
        iosVersion: { start: '', end: '', skip: '' },
        androidVersion: { start: '', end: '', skip: '' },
        appVersion: [{ start: '', end: '', skip: '', dataSetId: '' }],
        comment: '',
        backgroundUrl: '',
        backgroundName: '',
        id: '',
      },
      rules: {
        name: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
        type: [{ required: true, message: '分类类型不能为空', trigger: 'change' }],
        title: [{ required: true, message: '分类 Title 不能为空', trigger: 'blur' }],
        backgroundUrl: [{ required: true, message: '封面图不能为空', trigger: 'change' }],
      },
      isCreate: true,
      loading: false,
      uploadLoading: false,
      dataOptions: [],
      typeOptions: [],
      formBaseline: '',
      skipLeaveGuard: false,
    }
  },
  computed: {
    typeDisplayLabel() {
      const match = (this.typeOptions || []).find(
        (item) => String(item.categoryType) === String(this.ruleForm.type)
      )
      return (match && match.name) || this.ruleForm.type || ''
    },
  },
  async created() {
    this.isCreate = this.$route.path.indexOf('edit') === -1
    await this.getClassify()
    await this.getAllData()
    if (!this.isCreate) {
      await this.getRuleForm()
    } else {
      this.$nextTick(() => this.markFormBaseline())
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.skipLeaveGuard) {
      next()
      return
    }
    this.confirmLeaveIfDirty().then((ok) => {
      next(ok)
    })
  },
  methods: {
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.$message.error('请完成必填项')
          return false
        }

        const payload = {
          ...this.ruleForm,
          appVersion: this.setAppVersion([...this.ruleForm.appVersion]),
        }

        if (this.isCreate) {
          createCategory(payload)
            .then((res) => {
              if (res.success) {
                this.skipLeaveGuard = true
                this.$message.success('创建成功')
                const id = res.data
                if (id != null && id !== '') {
                  this.$router.push(`/collection/classify/info/${id}`)
                } else {
                  this.$router.push('/collection/classify/list')
                }
              } else {
                this.$message.error(res.errMessage || '创建失败')
              }
            })
            .catch((err) => {
              this.$message.error(String(err))
            })
          return
        }

        editCategory(payload).then((res) => {
          if (res.success) {
            this.skipLeaveGuard = true
            this.$message.success('保存成功')
            this.$router.push(`/collection/classify/info/${this.$route.params.id}`)
          } else {
            this.$message.error(res.errMessage || '保存失败')
          }
        })
      })
    },
    getRuleForm() {
      this.loading = true
      return getCategoryById({ id: this.$route.params.id })
        .then((res) => {
          if (res.success) {
            this.ruleForm.name = res.data.name
            this.ruleForm.type = this.getType(res.data.type)
            this.ruleForm.country = JSON.parse(res.data.country)
            this.ruleForm.iosVersion = this.getVersionData(res.data.iosApiVersion)
            this.ruleForm.androidVersion = this.getVersionData(res.data.androidApiVersion)
            const appVersion = JSON.parse(res.data.appVersion)
            if (appVersion.length > 0) {
              this.ruleForm.appVersion = appVersion
            }
            this.ruleForm.comment = res.data.remark
            this.ruleForm.backgroundUrl = res.data.icon
            this.ruleForm.status = res.data.status
            this.ruleForm.id = res.data.id
            this.ruleForm.title = res.data.title
            this.ruleForm.key = res.data.key
          }
        })
        .finally(() => {
          this.loading = false
          this.$nextTick(() => this.markFormBaseline())
        })
    },
    getType(type) {
      let resolved = ''
      this.typeOptions.forEach((item) => {
        if (item.name === type) {
          resolved = item.categoryType
        }
      })
      return resolved
    },
    getVersionData(val) {
      if (val === '') {
        return { start: '', end: '', skip: '' }
      }
      return JSON.parse(val)
    },
    getFileName(name) {
      return name.substring(0, name.lastIndexOf('.'))
    },
    customRequest(params) {
      const fileName = params.file.name
      if (!this.ruleForm.name) {
        this.ruleForm.name = this.getFileName(fileName)
      }
      this.uploadLoading = true
      const formData = new FormData()
      formData.append('file', params.file)
      uploadFile(formData)
        .then((res) => {
          if (res.success) {
            this.ruleForm.backgroundUrl = res.data
            this.ruleForm.backgroundName = fileName
            if (this.$refs.ruleForm) {
              this.$refs.ruleForm.clearValidate(['backgroundUrl'])
            }
          }
        })
        .finally(() => {
          this.uploadLoading = false
        })
    },
    onCoverCleared() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.validateField('backgroundUrl')
      }
    },
    setAppVersion(list) {
      for (let i = list.length - 1; i >= 0; i--) {
        if (
          list[i].start === '' &&
          list[i].end === '' &&
          list[i].skip === '' &&
          list[i].dataSetId === ''
        ) {
          list.splice(i, 1)
        }
      }
      return list
    },
    getAllData() {
      return getAllDataList().then((res) => {
        if (res.success) {
          this.dataOptions = res.data
        }
      })
    },
    goBack() {
      this.confirmLeaveIfDirty().then((ok) => {
        if (ok) {
          this.$router.push('/collection/classify/list')
        }
      })
    },
    async getClassify() {
      const res = await getClassifyResourceType()
      const payload = res.data
      if (payload && payload.success) {
        this.typeOptions = payload.data
      }
    },
    captureFormSnapshot() {
      return JSON.stringify(this.ruleForm)
    },
    markFormBaseline() {
      this.formBaseline = this.captureFormSnapshot()
    },
    isFormDirty() {
      if (!this.formBaseline) {
        return false
      }
      return this.captureFormSnapshot() !== this.formBaseline
    },
    confirmLeaveIfDirty(message) {
      if (this.skipLeaveGuard || !this.isFormDirty()) {
        return Promise.resolve(true)
      }
      return this.$confirm(
        message || '当前页面有未保存的修改，离开后将丢失。确定要离开吗？',
        '未保存的更改',
        {
          confirmButtonText: '离开',
          cancelButtonText: '继续编辑',
          type: 'warning',
        }
      )
        .then(() => {
          this.skipLeaveGuard = true
          return true
        })
        .catch(() => false)
    },
  },
}
</script>

<style scoped>
.createOrEditRoot {
  height: 100%;
}

.resourceFormPage__form {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.resourceFormPage__lead {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  min-width: 0;
  flex: 1;
}

.resourceFormPage__headerDock {
  position: sticky;
  top: 0;
  z-index: 40;
  flex-shrink: 0;
}

.resourceFormPage__headerDock .resourceFormPage__actionBar {
  position: relative;
  top: auto;
  z-index: 2;
}

.resourceFormPage__typeReadonly {
  font-size: var(--link-text-sm);
  color: var(--link-text-muted, #6b6560);
  padding: 4px 10px;
  border-radius: 6px;
  background: var(--link-field-bg, #f3f0ea);
  border: 1px solid var(--link-line-strong, #e5dfd6);
}

.resourceFormPage__pageTitle {
  margin: 0;
}

.fullContainer {
  width: 100%;
  height: 100%;
}

.main {
  padding: 20px;
}
</style>
